// loadUrlQueryRegion.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import addPendingRemoveSearchParams from '../action/addPendingRemoveSearchParams.js';
import updateConfigurations from '../action/updateConfigurations.js';
import {
  CONFIG_PRIORITY_CONFIGURE,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
  CONFIG_PRIORITY_PRESENCE_USER,
} from '../resource/configPriority.js';

/**
 * Load url query region
 * @kind action
 * @param {URLSearchParams} {searchParams} - search params containing view id.
 * @return {Promise} Action promise.
 */
const loadUrlQueryRegion =
  ({ searchParams }) =>
  async (dispatch, getState) => {
    const region = searchParams.get('region');
    if (region) {
      const priorityGroups = getOperationData(
        getState(),
        ['config'],
        'configurationGroups'
      );
      const configurationGroups =
        priorityGroups?.[CONFIG_PRIORITY_PRESENCE_USER] ||
        priorityGroups?.[CONFIG_PRIORITY_PRESENCE_CLIENT] ||
        priorityGroups?.[CONFIG_PRIORITY_CONFIGURE] ||
        {};
      if (Object.keys(configurationGroups).includes(region)) {
        dispatch(updateConfigurations({ configKey: region }));
        dispatch(addPendingRemoveSearchParams({ queryKeys: ['region'] }));
      }
    }
    return dispatch({ type: '' });
  };

export default loadUrlQueryRegion;
